module.exports = __webpack_public_path__ + "img/content4.c151f7b6.png";